import { Controller } from 'stimulus'

export default class BlogController extends Controller {
  static targets = ['codeBlock', 'demo', 'moreTagsButton']

  expandCodeBlock() {
    this.codeBlockTarget.classList.remove('highlighter-rouge--expandable')
  }

  displayIframe() {
    this.demoTarget.classList.add('is-loaded')
  }

  // eslint-disable-next-line class-methods-use-this
  showTags(event) {
    const parent = event.currentTarget.parentNode
    const collapsedTags = parent.querySelectorAll('.btc-tag--is-collapsed')
    collapsedTags.forEach((tag) => {
      tag.classList.remove('btc-tag--is-collapsed')
    })
    event.currentTarget.classList.add('is-hidden')
  }
}
